import { Flex, Text } from "@/base/components/index";
import { useContextModalHardwareInstall } from "../context/modal-hardware-install-context";
import { LocalizationText } from "@/app/index";
import { useModalHardwareInstallStyles } from "./modal-hardware-install.styles";

export const ModalHardwareInstallDescription = () => {
  const { styles } = useModalHardwareInstallStyles();
  const { hardwareItem, currentPageId, currentProcess } =
    useContextModalHardwareInstall();

  if (currentPageId === "loading") {
    return null;
  }

  return (
    <Flex vertical align="stretch" gap={4} className={styles.description}>
      <Text strong>{hardwareItem?.ProductName}</Text>

      {currentPageId === "business-unit-select" && (
        <Text>
          <LocalizationText value="modal.hardware.install.description.business.unit.assign.text" />
        </Text>
      )}

      {currentPageId === "business-unit-create" && (
        <Text>
          <LocalizationText value="modal.hardware.install.description.business.unit.create.text" />
        </Text>
      )}

      {currentPageId === "cr-select" && (
        <Text>
          <LocalizationText value="modal.hardware.install.description.cr.select.text" />
        </Text>
      )}

      {currentPageId === "finish" && currentProcess?.status === "loading" && (
        <Text>
          <LocalizationText value="modal.hardware.install.description.finish.progress.text" />
        </Text>
      )}
    </Flex>
  );
};
